import PropTypes from 'prop-types';
import cn from 'classnames';

import './cocRangeBar.scss';

export default function  CoCRangeBar ({ label = '',
                                        min = null,
                                        max = null,
                                        minUnit = null,
                                        maxUnit = null,
                                        minOut = null ,
                                        maxOut = null,
                                        status = '' })
{
  const rangeWidth = (min === null && max === null) ? '100%' : (min === null || max === null) ? '80%' : '60%';

  const minValue = min !== null ? `${min} ${minUnit}` : '';
  const maxValue = max !== null ? `${max} ${maxUnit}` : '';

  const leftOutWidth = min !== null ? 20 : 0;
  const rightOutWidth = max !== null ? 20 : 0;
  const minOutLeft = `${leftOutWidth * 0.65}%`;
  const maxOutLeft = `${100 - rightOutWidth * 0.65}%`;

  return (
    <div className={cn('coc-range-bar', status)}>
      <div className="range-bar-label">{label}</div>

      <div className="range-bar-container">

        {(minOut !== null) && <div className="out-value" style={{left: minOutLeft}}>
          {minOut}
          <div className="out-value-indicator" />
        </div>}

        {(maxOut !== null) && <div className="out-value" style={{left: maxOutLeft}}>
          {maxOut}
          <div className="out-value-indicator" />
        </div>}

        <div className="range-bar">
          <div className='range-out'  style={{width: min !== null ?'20%' : '0'}}/>
          <div className={cn('range-in', {active: status})} style={{width: rangeWidth}}/>
          <div className='range-out' style={{width: max !== null ?'20%' : '0'}}/>
        </div>
      </div>

      <div className="range-bar-values">
        <div className="min-range-value" style={{left: '20%'}}>{minValue}</div>
        <div className="max-range-value" style={{left: '80%'}}>{maxValue}</div>
      </div>
    </div>
  );
}

CoCRangeBar.propTypes = {
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  minUnit: PropTypes.string,
  maxUnit: PropTypes.string,
  minOut: PropTypes.number,
  maxOut: PropTypes.number,
  status: PropTypes.string,
};
